export default ['1.34',

  '1.33',

  '1.32'];
